"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openMachineDoor = openMachineDoor;
async function openMachineDoor(machineRepo, id) {
    return await machineRepo.openMachineDoor(id);
}
